
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type categoryListVehicleLabelRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function categoryListVehicleLabelRT(): TemplateResult<categoryListVehicleLabelRTRootProps> {
    return _createElement('span', {}, this.isVehicleSelected ? [
        'Search Results For: ',
        this.vehicleString
    ] : null, !this.isVehicleSelected ? ['Category List'] : null);
}
        export const componentNames = []